import Component from '../vendor/Component'
import axios from 'axios'

export default class CollectionFilters extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._filterTriggers = this._elem.querySelectorAll('[data-collection-filter-trigger]')
    this._sortDropdowns = this._elem.querySelectorAll('[data-sort-dropdown]')
    this._offset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'))
    this._drawerContainer = this._elem.querySelector('[data-collection-filters-drawer]')
    this._ctx.hydrate({ CollectionFiltersMounted: this._ctx.getState().CollectionFiltersMounted || false })
  }

  mount() {

    for (let dropdown of this._sortDropdowns) {
      dropdown.addEventListener('change', async e => {
        let baseURL = window.location.pathname
        let params = new URLSearchParams(window.location.search)
        params.set('sort_by', dropdown.value)
        await this._refreshCollection(`${baseURL}?${params.toString()}`)
      })
    }

    for (let trigger of this._filterTriggers) {
      trigger.addEventListener('click', async e => {
        e.preventDefault()

        let openFilters = [...new Set(Array.from(this._elem.querySelectorAll('[data-filter-item-label].open')).map(elem => elem.dataset.filterItemLabel))]
        let drawerOpen = this._drawerContainer.classList.contains('open')

        await this._refreshCollection(trigger.href, () => {
          let drawerContainer = this._elem.querySelector('[data-collection-filters-drawer]')

          if (drawerOpen) {
            drawerContainer.classList.add('open')
          }

          for (let filter of openFilters) {
            this._openFilter(filter)
          }
        })
      })
    }

    this._ctx.hydrate({ CollectionFiltersMounted: true })

    this._elem.classList.add('rendered')

    this._viewportLogic()
  }

  _viewportLogic() {
    let vh = window.innerHeight * 0.01;
    let vw = document.body.clientWidth * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    document.documentElement.style.setProperty('--vw', `${vw}px`);
  }

  _openFilter(name) {
    let elems = this._elem.querySelectorAll(`[data-filter-item-label="${name}"]`)
    let buttonElems = this._elem.querySelectorAll(`[data-filter-trigger-button="${name}"]`)

    for (let elem of elems) {
      elem.classList.add('open')
      elem.nextElementSibling.classList.add('open')
    }
    for (let button of buttonElems) {
      button.classList.add('active')
    }
  }

  async _refreshCollection(url, cb = false) {
    this._elem.classList.add('loading')
    this._drawerContainer.classList.add('loading')

    let { data } = await axios.get(url)
    let parser = new DOMParser()
    let html = parser.parseFromString(data, 'text/html')
    let fetchedElem = html.querySelector('[data-collection-filters]')

    let drawerOpen = this._drawerContainer.classList.contains('open')

    this._elem.innerHTML = fetchedElem.innerHTML

    if (cb) cb()

    this._ctx.emit('ffc--lazy-load-update')
    this._ctx.emit('ffc--quicklink-listen-to', null, this._elem)

    this._theme.mountComponents(this._elem.closest('[data-collection-filters-wrap]'))

    this._updateHistoryState(url)

    this._elem.classList.remove('loading')
    this._drawerContainer.classList.remove('loading')


    let scrolltToTop = window.pageYOffset + this._elem.getBoundingClientRect().top - this._offset + 1

    window.scrollTo({
      top: scrolltToTop
    })

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push((swat) => {
      swat.initializeActionButtons("[data-collection-filters]");
    });

  }

  _updateHistoryState(url) {
    window.history.replaceState({ path: url }, '', url)
  }
}